<template>
    <div class="courses-list-page" v-wechat-title="`精彩课堂_双优云桥-智慧研修平台`">
        <div class="courses-wrap">
            <div class="crumb-bar">
                <a href="javascript:;" @click.prevent="goHome">项目首页</a>
                <span class="sep">/</span>
                <span class="cur">精彩课堂</span>
            </div>

            <div class="panel" v-loading="loading">
                <div class="panel-hd">
                    <h2>课程列表</h2>
                    <label class="search-box">
                        <i class="el-icon-search"></i>
                        <input
                            v-model.trim="keyword"
                            type="search"
                            placeholder="搜索课程名称"
                        />
                    </label>
                </div>

                <div class="course-grid" v-if="displayList.length">
                    <a
                        v-for="(item, idx) in displayList"
                        :key="item.id || idx"
                        href="javascript:;"
                        class="course-tile"
                        @click.prevent="toCourseDetail(item, idx)"
                    >
                        <div class="course-thumb" :style="item.coverStyle">
                            <span class="course-badge" v-if="item.badge">{{ item.badge }}</span>
                        </div>
                        <div class="course-meta">
                            <h4>{{ item.title }}</h4>
                            <p>{{ item.desc }}</p>
                            <div class="course-tags" v-if="item.tags && item.tags.length">
                                <span
                                    v-for="tag in item.tags"
                                    :key="tag"
                                    class="course-tag"
                                >{{ tag }}</span>
                            </div>
                        </div>
                    </a>
                </div>

                <ph-empty
                    v-else-if="!loading"
                    size="page"
                    :text="keyword ? '未找到匹配的课程' : '暂无精彩课堂'"
                    :subtext="keyword ? '请尝试更换搜索关键词' : ''"
                />

                <div class="pager-wrap" v-if="showPager">
                    <pagination
                        :total="pages.total"
                        :page.sync="pages.currentPage"
                        :limit.sync="pages.pageSize"
                        :pageSizes="[12, 24, 36]"
                        @pagination="handlePageChange"
                    />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import pagination from '@/common/community/pagination.vue'
import PhEmpty from './components/ph-empty.vue'

export default {
    name: 'ProjectHomeCoursesList',
    components: { pagination, PhEmpty },
    data() {
        return {
            loading: false,
            keyword: '',
            pages: {
                currentPage: 1,
                pageSize: 12,
                total: 0
            },
            courseList: [],
            allListCache: [],
            searchTimer: null
        }
    },
    computed: {
        projectId() {
            return this.$route.params.id
        },
        displayList() {
            if (!this.keyword) return this.courseList
            const key = this.keyword.toLowerCase()
            return this.allListCache.filter(item =>
                (item.title || '').toLowerCase().includes(key)
            )
        },
        showPager() {
            return this.pages.total > 0 && !this.keyword
        }
    },
    methods: {
        goHome() {
            this.$router.push(`/projectHome/${this.projectId}`)
        },
        stripHtmlText(val) {
            if (!val) return ''
            return String(val)
                .replace(/<[^>]*>/g, '')
                .replace(/&nbsp;/gi, ' ')
                .replace(/&amp;/gi, '&')
                .replace(/&lt;/gi, '<')
                .replace(/&gt;/gi, '>')
                .replace(/\uFFFD/g, '')
                .replace(/[\uE000-\uF8FF]/g, '')
                .replace(/\s+/g, ' ')
                .trim()
        },
        resolveCourseCover(cover) {
            if (!cover) return ''
            if (cover.startsWith('http://') || cover.startsWith('https://') || cover.startsWith('//')) {
                return cover
            }
            return `${this.downloadURL}${cover}`
        },
        mapCourseItem(item) {
            const cover = this.resolveCourseCover(item && item.cover)
            const tags = []
            if (item.spxName) tags.push(item.spxName)
            const rawIntro = (item && (
                item.courseExplain
                || item.introduction
                || item.courseIntro
                || item.description
                || item.remark
            )) || ''
            return {
                id: item.courseId,
                title: item.courseName || '未命名课程',
                desc: this.stripHtmlText(rawIntro),
                tags,
                badge: '',
                coverStyle: cover
                    ? {
                        backgroundImage: `linear-gradient(180deg, transparent 40%, rgba(0,0,0,0.35)), url(${cover})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center'
                    }
                    : ''
            }
        },
        handlePageChange(data) {
            this.pages.currentPage = data.pageIndex
            this.pages.pageSize = data.pageSize
            this.keyword = ''
            this.fetchList()
        },
        async fetchList() {
            if (!this.projectId) {
                this.courseList = []
                this.allListCache = []
                this.pages.total = 0
                return
            }
            this.loading = true
            try {
                const res = await this.$Api.Paired.getSharedCourses({
                    page: this.pages.currentPage,
                    limit: this.pages.pageSize,
                    projectId: this.projectId
                })
                const data = (res && res.data) || {}
                const list = (data.records || []).map(item => this.mapCourseItem(item))
                this.courseList = list
                this.pages.total = data.total || 0
                if (!this.keyword) {
                    this.allListCache = list.slice()
                }
            } catch (e) {
                this.courseList = []
                this.pages.total = 0
            } finally {
                this.loading = false
            }
        },
        async fetchAllForSearch() {
            if (!this.projectId) {
                this.allListCache = []
                return
            }
            this.loading = true
            try {
                const res = await this.$Api.Paired.getSharedCourses({
                    page: 1,
                    limit: 500,
                    projectId: this.projectId
                })
                const data = (res && res.data) || {}
                this.allListCache = (data.records || []).map(item => this.mapCourseItem(item))
            } catch (e) {
                this.allListCache = []
            } finally {
                this.loading = false
            }
        },
        toCourseDetail(item, index) {
            if (!item || !item.id) return
            this.$router.push({
                path: `/course/${item.id}`,
                query: {
                    proid: this.projectId,
                    index,
                    breadNumber: 4
                }
            })
        }
    },
    mounted() {
        this.fetchList()
    },
    beforeDestroy() {
        if (this.searchTimer) clearTimeout(this.searchTimer)
    },
    watch: {
        '$route.params.id'() {
            this.pages.currentPage = 1
            this.keyword = ''
            this.fetchList()
        },
        keyword(val) {
            if (this.searchTimer) clearTimeout(this.searchTimer)
            this.searchTimer = setTimeout(async () => {
                if (!val) {
                    this.fetchList()
                    return
                }
                await this.fetchAllForSearch()
            }, 300)
        }
    }
}
</script>

<style lang="less" scoped>
.courses-list-page {
    background: #f5f7fa;
    min-height: 60vh;
    padding: 24px 0 48px;
    line-height: 1.5;
}

.courses-wrap {
    width: 990px;
    max-width: 100%;
    margin: 0 auto;
    box-sizing: border-box;
}

.crumb-bar {
    font-size: 13px;
    color: #999;
    margin-bottom: 16px;

    a {
        color: #01A2FD;
        text-decoration: none;
    }

    .sep {
        margin: 0 8px;
        color: #ccc;
    }

    .cur {
        color: #666;
    }
}

.panel {
    background: #fff;
    border: 1px solid rgba(199, 199, 199, 0.4);
    border-radius: 4px;
    overflow: hidden;
    min-height: 240px;
}

.panel-hd {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 16px;
    padding: 16px 20px;
    border-bottom: 1px solid #f0f3f7;

    h2 {
        margin: 0;
        font-size: 16px;
        font-weight: 400;
        color: #333;
    }
}

.search-box {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    padding: 6px 12px;
    border: 1px solid #e5e8ef;
    border-radius: 16px;
    background: #f8fafc;
    min-width: 200px;

    i {
        color: #999;
        font-size: 14px;
    }

    input {
        border: none;
        outline: none;
        background: transparent;
        font-size: 13px;
        color: #333;
        width: 100%;
        font-family: inherit;
    }
}

.course-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 20px;
    padding: 24px;
}

.course-tile {
    display: flex;
    flex-direction: column;
    border: 1px solid rgba(199, 199, 199, 0.4);
    border-radius: 6px;
    overflow: hidden;
    text-decoration: none;
    color: inherit;
    background: #fff;
    transition: box-shadow 0.2s, border-color 0.2s;

    &:hover {
        border-color: rgba(1, 162, 253, 0.45);
        box-shadow: 0 6px 18px rgba(1, 162, 253, 0.12);

        h4 {
            color: #01A2FD;
        }
    }
}

.course-thumb {
    height: 140px;
    background:
        linear-gradient(135deg, rgba(1, 162, 253, 0.75), rgba(23, 105, 250, 0.5)),
        linear-gradient(160deg, #1769FA, #01A2FD);
    background-size: cover;
    background-position: center;
    position: relative;
    display: flex;
    align-items: flex-end;
    padding: 12px;
    box-sizing: border-box;
}

.course-badge {
    padding: 3px 10px;
    background: rgba(255, 200, 50, 0.95);
    color: #5a3a00;
    font-size: 12px;
    font-weight: 400;
    border-radius: 3px;
}

.course-meta {
    padding: 14px 14px 16px;

    h4 {
        margin: 0 0 8px;
        font-size: 15px;
        font-weight: 700;
        color: #333;
        line-height: 1.4;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
        min-height: 42px;
    }

    p {
        margin: 0 0 10px;
        font-size: 12px;
        color: #999;
        line-height: 1.5;
        min-height: 36px;
        display: -webkit-box;
        -webkit-line-clamp: 2;
        -webkit-box-orient: vertical;
        overflow: hidden;
    }
}

.course-tags {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
}

.course-tag {
    font-size: 12px;
    color: #01A2FD;
    background: #EAF6FF;
    padding: 2px 8px;
    border-radius: 3px;
    max-width: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}

.pager-wrap {
    padding: 8px 16px 16px;
}

@media screen and (min-width: 1250px) {
    .courses-wrap {
        width: 1200px;
    }
}

@media (max-width: 960px) {
    .course-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 600px) {
    .course-grid {
        grid-template-columns: 1fr;
    }

    .panel-hd {
        flex-direction: column;
        align-items: flex-start;
    }
}
</style>
